var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.189 8.101a3.786 3.786 0 0 0 5.353 5.354l2.142-2.141-1.07-1.071-2.142 2.141a2.271 2.271 0 1 1-3.213-3.212l2.142-2.141L3.33 5.96zm4.283-4.283 1.07 1.071 2.142-2.141a2.271 2.271 0 1 1 3.212 3.212L9.755 8.1l1.07 1.071 2.142-2.141a3.786 3.786 0 0 0-5.354-5.354zm-1.607 5.89 1.071 1.07 5.354-5.353-1.07-1.071z"
  })));
};
export default SvgLink;